import {
  Component,
  effect,
  ElementRef,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { CompilingSectionService } from '../../../../services/compiling/section.service';
import { CompilingSubSectionComponent } from '../sub-section/sub-section.component';
import { CompilingDashboardService } from '../../../../pages/new-compiling-dashboard/compiling-dashboard.service';

@Component({
  selector: 'lib-compiling-section',
  templateUrl: './section.component.html',
  imports: [TooltipModule, CompilingSubSectionComponent],
  providers: [CompilingSectionService],
})
export class CompilingSectionComponent {
  protected sectionService = inject(CompilingSectionService);
  private readonly compilingDashboardService = inject(
    CompilingDashboardService,
    {
      optional: true,
    },
  );

  section = viewChild<ElementRef<HTMLDivElement>>('ref');
  uniqueId = input.required<string>();

  constructor() {
    effect(() => {
      this.sectionService.uniqueId = this.uniqueId();
    });

    effect(() => {
      const sectionToFocus = this.compilingDashboardService?.sectionToFocus();
      if (!sectionToFocus) return;

      const section = this.section()?.nativeElement;
      if (!section) return;

      if (sectionToFocus === this.uniqueId()) {
        setTimeout(() => {
          section.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
          this.compilingDashboardService?.sectionToFocus.set(undefined);
        }, 100);
      }
    });
  }
}
